import { Controller } from "stimulus"

// #1978: het venster Nieuwe lead. Wie iets heeft ingevuld en op Annuleren,
// het kruisje, Escape of de achtergrond klikt, krijgt eerst de vraag of de
// ingevulde gegevens weg mogen. Een lege voornaam en achternaam meldt het
// venster al bij het veld voordat het formulier naar de server gaat (Lead
// aanmaken; een concept mag zonder naam).
export default class extends Controller {
  static targets = ["formulier", "naamfout"]
  static values = { vraag: String }

  gewijzigd() {
    this.vuil = true
  }

  verzenden(event) {
    const knop = event.submitter
    if (knop && knop.name === "concept") {
      this.vuil = false
      return
    }
    const vorm = this.formulierTarget
    const voornaam = vorm.querySelector("[name='leadkaart[voornaam]']")
    const achternaam = vorm.querySelector("[name='leadkaart[achternaam]']")
    const leeg = [voornaam, achternaam].every((veld) => !veld || !veld.value.trim())
    if (leeg && this.hasNaamfoutTarget) {
      event.preventDefault()
      this.naamfoutTarget.hidden = false
      voornaam?.setAttribute("aria-invalid", "true")
      voornaam?.focus()
      return
    }
    this.vuil = false
  }

  annuleer(event) {
    if (!this.magWeg()) {
      event.preventDefault()
      return
    }
    const dialoog = this.dialoog()
    if (!dialoog) return
    event.preventDefault()
    this.leeg()
    dialoog.close()
  }

  escape(event) {
    if (this.magWeg()) {
      this.leeg()
      return
    }
    event.preventDefault()
  }

  achtergrond(event) {
    const dialoog = this.dialoog()
    if (!dialoog || event.target !== dialoog) return
    if (!this.magWeg()) return
    this.leeg()
    dialoog.close()
  }

  magWeg() {
    return !this.vuil || window.confirm(this.vraagValue)
  }

  leeg() {
    this.vuil = false
    if (this.hasFormulierTarget) this.formulierTarget.reset()
    if (this.hasNaamfoutTarget) this.naamfoutTarget.hidden = true
  }

  dialoog() {
    return this.element.tagName === "DIALOG" ? this.element : null
  }
}
